import { useGetPeriods, UseGetPeriodsInput } from "../../api/insights"
import { GetPeriodsOutput } from "../../api/insights/periods/utils"
import { usePolicyAndFleet } from "../PolicyAndFleetProvider"
import { useApi } from "./useApi"

export const useInsightPeriods = () => {
  const { policy } = usePolicyAndFleet()
  const [res, reload] = useGetPeriods({ policyId: policy.id })
  return useApi<GetPeriodsOutput, UseGetPeriodsInput>(res, reload)
}
